const GAINSIGHT_TRACKING_CATEGORY = {
  NAVIGATION: 'navigation',
  MONITORING: 'monitoring',
  MODELLING: 'modelling',
  ALERTS: 'alerts',
  EVENTS: 'events',
  TRAJECTORIES: 'trajectories',
  REPORTS: 'reports',
  PAGINATION: 'pagination',
} as const;

const FALLBACK_CATEGORY = 'other' as const;

type GainsightTrackingCategory = (typeof GAINSIGHT_TRACKING_CATEGORY)[keyof typeof GAINSIGHT_TRACKING_CATEGORY];

const PREFIX_TO_CATEGORY: Array<{ prefix: string; category: GainsightTrackingCategory }> = [
  { prefix: 'main-nav-bar-', category: GAINSIGHT_TRACKING_CATEGORY.NAVIGATION },
  { prefix: 'monitoring-', category: GAINSIGHT_TRACKING_CATEGORY.MONITORING },
  { prefix: 'map-layers-', category: GAINSIGHT_TRACKING_CATEGORY.MONITORING },
  { prefix: 'zoom-', category: GAINSIGHT_TRACKING_CATEGORY.MONITORING },
  { prefix: 'grid-', category: GAINSIGHT_TRACKING_CATEGORY.MONITORING },
  { prefix: 'analyse-drawer-', category: GAINSIGHT_TRACKING_CATEGORY.MONITORING },
  { prefix: 'modelling-', category: GAINSIGHT_TRACKING_CATEGORY.MODELLING },
  { prefix: 'alert-history-', category: GAINSIGHT_TRACKING_CATEGORY.ALERTS },
  { prefix: 'event-history-', category: GAINSIGHT_TRACKING_CATEGORY.EVENTS },
  { prefix: 'trajectories-', category: GAINSIGHT_TRACKING_CATEGORY.TRAJECTORIES },
  { prefix: 'historical-reports-', category: GAINSIGHT_TRACKING_CATEGORY.REPORTS },
  { prefix: 'pagination-', category: GAINSIGHT_TRACKING_CATEGORY.PAGINATION },
];

const DATA_TRACKING_PROP_ATTR = 'data-tracking-prop';

const getTrackingProps = (element?: Element): Record<string, unknown> => {
  if (!element) return {};
  const jsonValue = element.getAttribute(DATA_TRACKING_PROP_ATTR);
  if (!jsonValue?.trim()) return {};
  try {
    return JSON.parse(jsonValue);
  } catch {
    return {};
  }
};

export const getGainsightEventProperties = (trackingKey: string, element?: Element) => {
  const category =
    PREFIX_TO_CATEGORY.find(({ prefix }) => trackingKey.toLowerCase().startsWith(prefix))?.category ??
    FALLBACK_CATEGORY;

  return {
    category,
    ...getTrackingProps(element),
  };
};
